module.exports = __webpack_public_path__ + "img/chevron-right-customs.9275f47b.svg";